import styled from 'styled-components';

export const Address = styled.address`
  font-style: normal;
`;

export default Address;
